import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiLinux,
  SiGithub,
  SiRender
} from "react-icons/si";
import { DiHeroku } from "react-icons/di";

const calculateExperience = (startDate) => {
  const start = new Date(startDate);
  const now = new Date();
  const diffTime = Math.abs(now - start);
  const diffMonths = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30));
  return diffMonths;
};

const ToolIcon = ({ icon: Icon, name, category, startDate }) => {
  const experience = calculateExperience(startDate);

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`tooltip-${name}`} className="custom-tooltip">
          <div className="tooltip-content">
            <span className="tooltip-category">{category}</span>
            <strong className="tooltip-title">{name}</strong>
            <span className="experience-text">{experience} months</span>
          </div>
        </Tooltip>
      }
    >
      <Col xs={4} md={2} className="tech-icons">
        <div className="tool-icon-wrapper">
          <Icon className="tool-icon" />
        </div>
      </Col>
    </OverlayTrigger>
  );
};

function Toolstack() {
  const toolStack = [
    { icon: SiGithub, name: "GitHub", category: "Version Control", startDate: "2023-09-01" },
    { icon: SiLinux, name: "Linux", category: "Operating System", startDate: "2023-08-01" },
    { icon: SiVisualstudiocode, name: "VS Code", category: "IDE", startDate: "2023-08-01" },
    { icon: SiPostman, name: "Postman", category: "API Tool", startDate: "2024-01-01" },
    { icon: SiSlack, name: "Slack", category: "Communication", startDate: "2024-05-01" },
    { icon: SiVercel, name: "Vercel", category: "Deployment", startDate: "2023-11-01" },
    { icon: SiRender, name: "Render", category: "Cloud Platform", startDate: "2024-05-01" },
    { icon: DiHeroku, name: "Heroku", category: "PaaS", startDate: "2024-06-01" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {toolStack.map((tool, index) => (
        <ToolIcon key={index} {...tool} />
      ))}
    </Row>
  );
}

export default Toolstack;